import { reatomAsync, withAbort, withDataAtom } from "@reatom/async";
import { onConnect } from "@reatom/framework";
import { StatusResponseOverallEnum } from "definitions/poizon-bff";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

const POLL_INTERVAL_MS = 60_000;

export const getServiceStatusAction = reatomAsync(() => {
  return API.serviceMonitoringApi
    .serviceMonitoringControllerGetStatus()
    .then((response) => response.data);
}, "getServiceStatusAction").pipe(
  withAbort(),
  withDataAtom({
    overall: StatusResponseOverallEnum.Unknown,
    updated_at: "",
    components: [],
  }),
  withIsLoadingAtom(),
);

onConnect(getServiceStatusAction.dataAtom, (ctx) => {
  getServiceStatusAction(ctx);
  const interval = setInterval(
    () => getServiceStatusAction(ctx),
    POLL_INTERVAL_MS,
  );
  return () => clearInterval(interval);
});
